import React from "react";
//import { useState } from "react";
// import { Icon } from "semantic-ui-react";
import Icon from "../Components/Icon";

const Device = (props) => {
  //const [loading, setloading] = useState(false);

  //console.log(props);
  let click = () => console.log("Must be unkown: " + props.Status);
  if (props.Status === 0) click = props.Activate;
  else if (props.Status === 1) click = props.Deactivate;
  else if (props.Status === 2)
    click = () => console.log("Uknown status: " + props.Status);

  const getIcon = (loading, type, status) => {
    if (loading) {
      return <Icon icon="Loading" />;
    } else {
      if (status === 2) return <Icon icon="Uknown" color="grey" />;
      if (type === "Door") {
        if (status === 0) {
          return <Icon icon="Unlock" color="green" />;
        } else {
          return <Icon icon="Lock" color="red" />;
        }
      } else {
        if (status === 0) {
          return <Icon icon="led" color="green" />;
        } else {
          return <Icon icon="led" color="red" />;
        }
      }
    }
  };

  const getStatus = (loading, type, status) => {
    if (loading) {
      return (
        <div className="loading_icon">
          <Icon icon="Loading" size="36" />
        </div>
      );
    } else {
      if (status === 2) return "Unknown";
      if (type === "Door") {
        if (status === 0) {
          return "Unlocked";
        } else {
          return "Locked";
        }
      } else {
        if (status === 0) {
          return "Disarmed";
        } else {
          return "Armed";
        }
      }
    }
  };
  return (
    <div
      className={"device style status_" + props.Status + " " + props.Type}
      onClick={click}
    >
      {/* <div className="device_boundry"> */}
      <div className="device_name_row">
        <div className="device_name">
          <Icon
            icon={
              props.Type !== "Alarm"
                ? props.Type
                : props.Name === "Perimeter"
                ? "Alarm"
                : "Motion"
            }
            color="grey"
          />
          <div className="device_text">{props.Name}</div>
        </div>

        <div className="device_name_status">
          {getIcon(props.Loading, props.Type, props.Status)}
        </div>
      </div>
      <div className="device_status">
        <div className="device_status_label">Status:</div>
        <div className="device_status_value">
          {getStatus(props.Loading, props.Type, props.Status)}
        </div>
      </div>
      {/* </div> */}
    </div>
  );
};

export default Device;
